module.exports = __webpack_public_path__ + "img/mazda-New.3232d2b4.png";